(function () {
  const DateTime  = luxon.DateTime;
  const CST_ZONE  = 'America/Chicago';
  //const CST_ZONE = 'America/Regina'; // fixed UTC-6 with no DST

  // ── Read configuration from Shopify settings ──────────────────────────────
  const cfg = window.sw_config || {};
  const ENABLED        = cfg.enabled !== false;
  const CUTOFF_DAY     = cfg.cutoff_day     || 6;   // hasta sábado por defecto
  const CUTOFF_H       = cfg.cutoff_hours   || 11;
  const CUTOFF_M       = cfg.cutoff_minutes || 0;
  const PREP_DAYS      = cfg.prep_days      || 0;
  // Días hábiles: si viene vacío del admin, default lun–sáb (1–6)
  const BUSINESS_DAYS  = (cfg.business_days && cfg.business_days.length > 0)
                           ? cfg.business_days.map(Number)
                           : [1, 2, 3, 4, 5, 6];
  // Blackout days: string "YYYY-MM-DD,YYYY-MM-DD" → Set para lookup O(1)
  const BLACKOUT_SET   = new Set(
    (cfg.blackout_days || '').split(',').map(s => s.trim()).filter(Boolean)
  );

  // ─── QA override state ───────────────────────────────────────────────────
  // qaOverride = { isoDate: 'YYYY-MM-DD', time: 'HH:MM', tz: 'IANA/Zone' }
  // null → uses the browser's actual local time
  let qaOverride = null;
  // ─────────────────────────────────────────────────────────────────────────

  /** 
    Returns true if a date (DateTime) is a business day:
    - Its weekday is in BUSINESS_DAYS
    - It is not in BLACKOUT_SET
  */
  function isBusinessDay(dt) {
    const iso = dt.toISODate(); // 'YYYY-MM-DD'
    return BUSINESS_DAYS.includes(dt.weekday) && !BLACKOUT_SET.has(iso);
  }

  /**
   * Advances to the next business day (excluding the current day).
   */
  function nextBusinessDay(dt) {
    let candidate = dt.plus({ days: 1 });
    while (!isBusinessDay(candidate)) {
      candidate = candidate.plus({ days: 1 });
    }
    return candidate;
  }

  /**
   * Advances N business days from dt (excluding dt itself).
   */
  function addBusinessDays(dt, n) {
    let result = dt;
    for (let i = 0; i < n; i++) {
      result = nextBusinessDay(result);
    }
    return result;
  }

  /**
   * Returns the DateTime "now" in CST.
   * If a QA override is active, it constructs that instant in the "user" time zone
   * and then converts it to CST to apply business rules.
   */
  function getNowCST() {
    if (qaOverride) {
      const userDT = DateTime.fromISO(qaOverride.isoDate + 'T' + qaOverride.time, { zone: qaOverride.tz });
      return userDT.setZone(CST_ZONE);
    }
    return DateTime.now().setZone(CST_ZONE);
  }

  /**
   * Local time zone: QA override or the browser’s actual time zone.
   */
  function getUserZone() {
    if (qaOverride) return qaOverride.tz;
    return DateTime.local().zoneName;
  }

  /**
    Calculates the shipping date.
    Logic:
    1. Determine the "base day" (when preparation starts):
    - If today is a business day AND the weekday <= CUTOFF_DAY AND it is before the cutoff → base = today
    - Otherwise → base = next business day
    
    2. Add PREP_DAYS business days to the base day.
    - With 0 prep days: the base day IS the shipping day.
    - With 1 prep day: advance 1 business day from the base.
    - With N prep days: advance N business days.
  */
  function getShipDate(nowCST) {
    const dow          = nowCST.weekday;
    const h            = nowCST.hour;
    const m            = nowCST.minute;
    const beforeCutoff = h < CUTOFF_H || (h === CUTOFF_H && m < CUTOFF_M);
    const todayIsBase  = isBusinessDay(nowCST) && dow <= CUTOFF_DAY && beforeCutoff;

    const base = todayIsBase ? nowCST : nextBusinessDay(nowCST);
    return addBusinessDays(base, PREP_DAYS);
  }

  function formatShipDate(dt, nowCST) {
    if (dt.hasSame(nowCST, 'day')) return 'Today';
    if (dt.hasSame(nowCST.plus({ days: 1 }), 'day')) return 'Tomorrow';
    return dt.setLocale('en').toFormat('EEE d MMM');
  }

  /**
   * Converts 11:00 AM CST of the current day to the user's local time zone.
   * A user in CST will see "11:00 AM CDT/CST", one in PST will see "9:00 AM PDT/PST", etc.
   */
  function localCutoffStr(nowCST, userZone) {
    const cutoffCST   = nowCST.set({ hour: CUTOFF_H, minute: CUTOFF_M, second: 0, millisecond: 0 });
    const cutoffLocal = cutoffCST.setZone(userZone);
    const time        = cutoffLocal.toFormat('h:mm a');
    const abbr        = cutoffLocal.toFormat('ZZZZ'); // e.g. CST, CDT, PST, EST
    return { time, abbr };
  }

  function render() {
    if (!ENABLED) return;

    const nowCST   = getNowCST();
    const userZone = getUserZone();
    const shipDt   = getShipDate(nowCST);
    const cut      = localCutoffStr(nowCST, userZone);

    document.getElementById('sw-ship-date').textContent = formatShipDate(shipDt, nowCST);

    const shipDateElement = document.getElementById('sw-ship-date-sticky');

    if (shipDateElement) {
      shipDateElement.textContent = formatShipDate(shipDt, nowCST);
    }

    // The message only appears from 00:00 to before the cutoff.
    const msgEl        = document.getElementById('sw-cutoff-msg');
    const msgSticky    = document.getElementById('sw-cutoff-msg-sticky');

    const h            = nowCST.hour;
    const m            = nowCST.minute;
    const beforeCutoff = h < CUTOFF_H || (h === CUTOFF_H && m < CUTOFF_M);

    if (!beforeCutoff) {
      msgEl.innerHTML    = 'If ordered <strong>before ' + cut.time + '</strong> ' + cut.abbr + ':';
      msgEl.style.display = '';

      if(msgSticky) {
        msgSticky.innerHTML    = 'If ordered <strong>before ' + cut.time + '</strong> ' + cut.abbr + ':';
        msgSticky.style.display = '';
      }
    } else {
      msgEl.style.display = 'none';

      if(msgSticky) {
        msgSticky.style.display = 'none';
      }
    }

    // Mostrar el widget
    const widget = document.getElementById('shipping-widget');
    if (widget) widget.classList.remove('sw-wrapper-test');

    // Mostrar QA panel si existe
    const qaPanel = document.getElementById('sw-qa-panel');
    if (qaPanel) qaPanel.classList.remove('sw-wrapper-test');
  }

  var qaActiveChk = document.getElementById('sw-qa-active');
  var qaApplyBtn  = document.getElementById('sw-qa-apply');
  var qaBody      = document.getElementById('sw-qa-body');
  var qaDateIn    = document.getElementById('sw-qa-date');
  var qaTimeIn    = document.getElementById('sw-qa-time');
  var qaTzSel     = document.getElementById('sw-qa-tz');

  if (qaActiveChk) {
    // Pre-llenar inputs con fecha/hora actual
    var nowInit = DateTime.now();
    if (qaDateIn) qaDateIn.value = nowInit.toFormat('yyyy-MM-dd');
    if (qaTimeIn) qaTimeIn.value = nowInit.toFormat('HH:mm');

    qaActiveChk.addEventListener('change', function () {
      var active = this.checked;
      if (qaBody) {
        qaBody.querySelectorAll('input:not(#sw-qa-active), select, button').forEach(function(el) {
          el.disabled = !active;
        });
      }
      if (!active) {
        qaOverride = null;
        render();
      }
    });

    if (qaApplyBtn) {
      qaApplyBtn.addEventListener('click', function () {
        if (!qaActiveChk.checked) return;
        qaOverride = {
          isoDate : qaDateIn.value || DateTime.now().toFormat('yyyy-MM-dd'),
          time    : qaTimeIn.value || '09:00',
          tz      : qaTzSel.value  || 'America/Chicago'
        };
        render();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();

// ── Ocultar shipping widget y free-shipping banner cuando sold out ────────────
(function () {
  function setShippingVisibility(soldOut) {
    var widget        = document.getElementById('shipping-widget');
    var widgetSticky  = document.getElementById('shipping-widget-sticky');
    var freeBanner    = document.querySelector('.product-free-shipping');
    var purchaseDetails = document.querySelector('.purchase-details');
    var videoStories  = document.querySelectorAll('.video-stories');
    var productForm   = document.getElementById('product-form');

    if (widget)          widget.style.display          = soldOut ? 'none' : '';
    if (widgetSticky)    widgetSticky.style.display     = soldOut ? 'none' : '';
    if (freeBanner)      freeBanner.style.display       = soldOut ? 'none' : '';
    if (purchaseDetails) purchaseDetails.style.display  = soldOut ? 'none' : '';
    videoStories.forEach(function (el) { el.style.marginBottom = soldOut ? '0px' : ''; });
    if (productForm)     productForm.style.marginBottom  = soldOut ? '0px' : '';
  }

  // El tema Parallax llama a window.selectCallback(variant, selector) en cada
  // cambio de variante. Encadenamos nuestro código después del original.
  function hookSelectCallback() {
    var original = window.selectCallback;
    window.selectCallback = function (variant, selector) {
      if (typeof original === 'function') original(variant, selector);
      // variant es null si ninguna combinación de opciones es válida
      var soldOut = !variant || !variant.available;
      setShippingVisibility(soldOut);
    };
  }

  // Estado inicial: leer el primer variant disponible del form
  function initVisibility() {
    var form = document.querySelector('form.product_form');
    if (!form) return;
    try {
      var data = JSON.parse(form.getAttribute('data-product') || 'null');
      if (!data) return;
      // Tomar el variant que coincide con el ID actualmente seleccionado
      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;
      var variant = variantId
        ? data.variants.find(function (v) { return v.id === variantId; })
        : data.variants[0];
      setShippingVisibility(!variant || !variant.available);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hookSelectCallback();
      initVisibility();
    });
  } else {
    hookSelectCallback();
    initVisibility();
  }
})();